module.exports = __webpack_public_path__ + "img/work-order.afa29084.svg";